<template>
  <div>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="deleteWorkType">
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    deleteWorkType: function() {
      this.params.context.componentParent.deleteWorkType(this.params.data);
    }
  }
};
</script>